"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2403],{

/***/ 32403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_InputNumber; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconUp/index.js
var IconUp = __webpack_require__(2295);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconDown/index.js
var IconDown = __webpack_require__(31944);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconPlus/index.js
var IconPlus = __webpack_require__(84566);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconMinus/index.js
var IconMinus = __webpack_require__(81041);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/keycode.js
var keycode = __webpack_require__(85660);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 3 modules
var ConfigProvider = __webpack_require__(40360);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Input/index.js + 6 modules
var Input = __webpack_require__(1393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(81109);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/InputNumber/useSelectionRange.js



function useSelectionRange(_a) {
    var inputElement = _a.inputElement, inputValue = _a.inputValue;
    // Selection position from the tail (e.g. 1234|56, this value will be 2)
    var refSelectionPosition = (0,react.useRef)(null);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        try {
            var position = refSelectionPosition.current;
            if (inputElement && inputValue && (0,is/* isNumber */.hj)(position)) {
                var start = Math.max(0, inputValue.length - position);
                inputElement.setSelectionRange(start, start);
            }
        }
        catch (err) {
            console.warn('Failed to reset input selection range position', err);
        }
    }, [inputValue]);
    return function (event) {
        var _a = event.target, end = _a.selectionEnd, value = _a.value;
        if ((0,is/* isNumber */.hj)(end)) {
            refSelectionPosition.current = value.length - end;
        }
    };
}

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/InputNumber/utils.js
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * Judge whether a number is scientific notation
 */
function isE(number) {
    return !Number.isNaN(Number(number)) && String(number).includes('e');
}
/**
 * Judge whether BigInt is supported by current env
 */
function supportBigInt() {
    return typeof BigInt === 'function';
}
/**
 * Get precision of a number, include scientific notation like 1e-10
 */
function getNumberPrecision(number) {
    var numStr = String(number);
    if (isE(number)) {
        var precision_1 = Number(numStr.slice(numStr.indexOf('e-') + 2));
        numStr.replace(/\.(\d+)/, function (_, $1) {
            precision_1 += $1.length;
            return _;
        });
        return precision_1;
    }
    return numStr.includes('.') && validateNumber(numStr)
        ? numStr.length - numStr.indexOf('.') - 1
        : 0;
}
/**
 * Convert number to non-scientific notation
 */
function toSafeString(number) {
    var nativeNumberStr = String(number);
    if (isE(number)) {
        if (number < Number.MIN_SAFE_INTEGER) {
            return supportBigInt() ? BigInt(number).toString() : Number.MIN_SAFE_INTEGER.toString();
        }
        if (number > Number.MAX_SAFE_INTEGER) {
            return supportBigInt() ? BigInt(number).toString() : Number.MAX_SAFE_INTEGER.toString();
        }
        // This may lose precision, but foFixed must accept argument in the range 0-100
        var precision = getNumberPrecision(nativeNumberStr);
        nativeNumberStr = Number(number).toFixed(Math.min(100, precision));
    }
    return trimNumber(nativeNumberStr).fullStr;
}
/**
 * Judge whether a number is valid
 */
function validateNumber(num) {
    if (typeof num === 'number') {
        return !Number.isNaN(num);
    }
    if (!num) {
        return false;
    }
    return (
    // 1.1
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) ||
        // 1.
        /^\s*-?\d+\.\s*$/.test(num) ||
        // .1
        /^\s*-?\.\d+\s*$/.test(num));
}
function trimNumber(numStr) {
    var str = numStr.trim();
    var negative = false;
    str = str
        // Remove negative-label(-) at head.
        .replace(/^-/, function () {
        negative = true;
        return '';
    })
        // Remove useless 0 at decimal end. `1.00100` => `1.001`
        .replace(/(\.\d*[^0])0*$/, '$1')
        // Remove useless decimal.
        .replace(/\.0*$/, '')
        // Remove useless 0 at head.
        .replace(/^0+/, '')
        // Add 0 before empty dot. `.1` => `0.1`
        .replace(/^\./, '0.');
    var trimStr = str || '0';
    var _a = __read(trimStr.split('.'), 2), _b = _a[0], integerStr = _b === void 0 ? '0' : _b, _c = _a[1], decimalStr = _c === void 0 ? '0' : _c;
    if (integerStr === '0' && decimalStr === '0') {
        negative = false;
    }
    var negativeStr = negative ? '-' : '';
    return {
        negative: negative,
        negativeStr: negativeStr,
        trimStr: trimStr,
        integerStr: integerStr,
        decimalStr: decimalStr,
        fullStr: "" + negativeStr + trimStr,
    };
}

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/InputNumber/Decimal.js
var Decimal_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

var BigIntDecimal = /** @class */ (function () {
    function BigIntDecimal(value) {
        this.origin = '';
        this.origin = String(value);
        if ((!value && value !== 0) || !this.origin.trim()) {
            this.isEmpty = true;
            return;
        }
        if (value === '-') {
            this.isNaN = true;
            return;
        }
        var safeValueString = toSafeString(value);
        if (validateNumber(safeValueString)) {
            var _a = trimNumber(safeValueString), negative = _a.negative, trimStr = _a.trimStr;
            var _b = Decimal_read(trimStr.split('.'), 2), integerStr = _b[0], _c = _b[1], decimalStr = _c === void 0 ? '0' : _c;
            this.isNegative = negative;
            this.integer = BigInt(integerStr);
            this.decimal = BigInt(decimalStr);
            this.decimalLen = decimalStr.length;
        }
        else {
            this.isNaN = true;
        }
    }
    Object.defineProperty(BigIntDecimal.prototype, "isInvalid", {
        get: function () {
            return this.isEmpty || this.isNaN;
        },
        enumerable: false,
        configurable: true
    });
    BigIntDecimal.prototype.getMark = function () {
        return this.isNegative ? '-' : '';
    };
    BigIntDecimal.prototype.getIntegerStr = function () {
        return this.integer.toString();
    };
    BigIntDecimal.prototype.getDecimalStr = function () {
        return this.decimal.toString().padStart(this.decimalLen, '0');
    };
    BigIntDecimal.prototype.alignDecimal = function (decimalLength) {
        return BigInt("" + this.getMark() + this.getIntegerStr() + this.getDecimalStr().padEnd(decimalLength, '0'));
    };
    BigIntDecimal.prototype.negate = function () {
        var numStr = this.toString();
        return new BigIntDecimal(numStr.startsWith('-') ? numStr.slice(1) : "-" + numStr);
    };
    BigIntDecimal.prototype.add = function (value) {
        var offset = new BigIntDecimal(value);
        if (offset.isInvalid) {
            return this;
        }
        if (this.isInvalid) {
            return offset;
        }
        var maxDecimalLength = Math.max(this.decimalLen, offset.decimalLen);
        var thisAlignedDecimal = this.alignDecimal(maxDecimalLength);
        var offsetAlignedDecimal = offset.alignDecimal(maxDecimalLength);
        var valueStr = (thisAlignedDecimal + offsetAlignedDecimal).toString();
        var _a = trimNumber(valueStr), negativeStr = _a.negativeStr, trimStr = _a.trimStr;
        var hydrateValueStr = "" + negativeStr + trimStr.padStart(maxDecimalLength + 1, '0');
        return new BigIntDecimal(hydrateValueStr.slice(0, -maxDecimalLength) + "." + hydrateValueStr.slice(-maxDecimalLength));
    };
    BigIntDecimal.prototype.equals = function (target) {
        return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
    };
    BigIntDecimal.prototype.less = function (target) {
        return this.isInvalid || target.isInvalid
            ? false
            : this.add(target.negate().toString()).toNumber() < 0;
    };
    BigIntDecimal.prototype.toNumber = function () {
        return this.isNaN ? NaN : Number(this.toString());
    };
    BigIntDecimal.prototype.toString = function (options) {
        if (options === void 0) { options = { safe: true }; }
        var safe = options.safe, precision = options.precision;
        var result = safe
            ? this.isInvalid
                ? ''
                : trimNumber("" + this.getMark() + this.getIntegerStr() + "." + this.getDecimalStr()).fullStr
            : this.origin;
        return typeof precision === 'number' ? toFixed(result, precision) : result;
    };
    return BigIntDecimal;
}());
var NumberDecimal = /** @class */ (function () {
    function NumberDecimal(value) {
        this.origin = '';
        this.origin = String(value);
        this.number = Number(value);
        if ((!value && value !== 0) || !this.origin.trim()) {
            this.isEmpty = true;
        }
        else {
            this.isNaN = Number.isNaN(this.number);
        }
    }
    Object.defineProperty(NumberDecimal.prototype, "isInvalid", {
        get: function () {
            return this.isEmpty || this.isNaN;
        },
        enumerable: false,
        configurable: true
    });
    NumberDecimal.prototype.negate = function () {
        return new NumberDecimal(-this.toNumber());
    };
    NumberDecimal.prototype.equals = function (target) {
        return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
    };
    NumberDecimal.prototype.less = function (target) {
        return this.isInvalid || target.isInvalid
            ? false
            : this.add(target.negate().toString()).toNumber() < 0;
    };
    NumberDecimal.prototype.add = function (value) {
        var offset = new NumberDecimal(value);
        if (offset.isInvalid) {
            return this;
        }
        if (this.isInvalid) {
            return offset;
        }
        var result = this.number + offset.number;
        if (result > Number.MAX_SAFE_INTEGER) {
            return new NumberDecimal(Number.MAX_SAFE_INTEGER);
        }
        if (result < Number.MIN_SAFE_INTEGER) {
            return new NumberDecimal(Number.MIN_SAFE_INTEGER);
        }
        var maxPrecision = Math.max(getNumberPrecision(this.number), getNumberPrecision(offset.number));
        return new NumberDecimal(result.toFixed(maxPrecision));
    };
    NumberDecimal.prototype.toNumber = function () {
        return this.number;
    };
    NumberDecimal.prototype.toString = function (options) {
        if (options === void 0) { options = { safe: true }; }
        var safe = options.safe, precision = options.precision;
        var result = safe ? (this.isInvalid ? '' : toSafeString(this.number)) : this.origin;
        return typeof precision === 'number' ? toFixed(result, precision) : result;
    };
    return NumberDecimal;
}());
function getDecimal(value) {
    return supportBigInt() ? new BigIntDecimal(value) : new NumberDecimal(value);
}
/**
 * Replace String.prototype.toFixed like Math.round
 * If cutOnly is true, just slice the tail
 * e.g. Decimal.toFixed(0.15) will return 0.2, not 0.1
 */
function toFixed(numStr, precision, cutOnly) {
    if (cutOnly === void 0) { cutOnly = false; }
    if (numStr === '') {
        return '';
    }
    var separator = '.';
    var _a = trimNumber(numStr), negativeStr = _a.negativeStr, integerStr = _a.integerStr, decimalStr = _a.decimalStr;
    var precisionDecimalStr = "" + separator + decimalStr;
    var numberWithoutDecimal = "" + negativeStr + integerStr;
    if (precision >= 0) {
        var advancedNum = Number(decimalStr[precision]);
        if (advancedNum >= 5 && !cutOnly) {
            var advancedDecimal = getDecimal(numStr).add(negativeStr + "0." + '0'.repeat(precision) + (10 - advancedNum));
            return toFixed(advancedDecimal.toString(), precision, cutOnly);
        }
        return precision === 0
            ? numberWithoutDecimal
            : "" + numberWithoutDecimal + separator + decimalStr
                .padEnd(precision, '0')
                .slice(0, precision);
    }
    return "" + numberWithoutDecimal + (precisionDecimalStr === '.0' ? '' : precisionDecimalStr);
}

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/InputNumber/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var InputNumber_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};














// Value's auto change speed when user holds on plus or minus
var AUTO_CHANGE_INTERVAL = 200;
// Delay to auto change value when user holds on plus or minus
var AUTO_CHANGE_START_DELAY = 1000;
var defaultProps = {
    max: Infinity,
    min: -Infinity,
    step: 1,
    mode: 'embed',
    parser: function (input) { return (input === null || input === void 0 ? void 0 : input.replace(/[^\w\.-]+/g, '')) || ''; },
};
function InputNumber(baseProps, ref) {
    var _a;
    var _b;
    var _c = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _c.getPrefixCls, ctxSize = _c.size, componentConfig = _c.componentConfig;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.InputNumber);
    var className = props.className, style = props.style, defaultValue = props.defaultValue, disabled = props.disabled, error = props.error, readOnly = props.readOnly, strictMode = props.strictMode, placeholder = props.placeholder, hideControl = props.hideControl, suffix = props.suffix, prefix = props.prefix, icons = props.icons, mode = props.mode, size = props.size, step = props.step, precision = props.precision, min = props.min, max = props.max, parser = props.parser, formatter = props.formatter, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, onKeyDown = props.onKeyDown, rest = __rest(props, ["className", "style", "defaultValue", "disabled", "error", "readOnly", "strictMode", "placeholder", "hideControl", "suffix", "prefix", "icons", "mode", "size", "step", "precision", "min", "max", "parser", "formatter", "onBlur", "onFocus", "onChange", "onKeyDown"]);
    var prefixCls = getPrefixCls('input-number');
    var mergedSize = size || ctxSize;
    var mergedPrecision = (function () {
        if ((0,is/* isNumber */.hj)(precision)) {
            var decimal = ("" + step).split('.')[1];
            var stepPrecision = (decimal && decimal.length) || 0;
            return Math.max(stepPrecision, precision);
        }
        return null;
    })();
    var _d = InputNumber_read((0,react.useState)(function () {
        return getDecimal('value' in props ? props.value : 'defaultValue' in props ? defaultValue : undefined);
    }), 2), innerValue = _d[0], setInnerValue = _d[1];
    var _e = InputNumber_read((0,react.useState)(''), 2), inputValue = _e[0], setInputValue = _e[1];
    var _f = InputNumber_read((0,react.useState)(false), 2), isOutOfRange = _f[0], setIsOutOfRange = _f[1];
    var _g = InputNumber_read((0,react.useState)(false), 2), isUserTyping = _g[0], setIsUserTyping = _g[1];
    var refAutoTimer = (0,react.useRef)(null);
    var refInput = (0,react.useRef)(null);
    // Ref to keep track of whether user has taken operations since the last change of prop value
    var refHasOperateSincePropValueChanged = (0,react.useRef)(false);
    var value = (0,react.useMemo)(function () {
        return 'value' in props ? getDecimal(props.value) : innerValue;
    }, [props.value, innerValue]);
    var _h = InputNumber_read((0,react.useMemo)(function () {
        return [getDecimal(max), getDecimal(min)];
    }, [max, min]), 2), maxDecimal = _h[0], minDecimal = _h[1];
    (0,react.useImperativeHandle)(ref, function () { return refInput.current; }, []);
    var setValue = function (newValue) {
        setInnerValue(newValue);
        if (!newValue.equals(value) && onChange) {
            var newValueStr = newValue.toString({ safe: true, precision: mergedPrecision });
            onChange(newValue.isEmpty
                ? undefined
                : strictMode
                    ? newValueStr
                    : newValue.isNaN
                        ? NaN
                        : Number(newValueStr));
        }
    };
    var stop = function () {
        refAutoTimer.current && clearTimeout(refAutoTimer.current);
        refAutoTimer.current = null;
    };
    var getLegalValue = (0,react.useCallback)(function (changedValue) {
        var finalValue = changedValue;
        if (finalValue.less(minDecimal)) {
            finalValue = minDecimal;
        }
        else if (maxDecimal.less(finalValue)) {
            finalValue = maxDecimal;
        }
        return finalValue;
    }, [minDecimal, maxDecimal]);
    (0,react.useEffect)(function () {
        return function () { return stop(); };
    }, []);
    (0,react.useEffect)(function () {
        refHasOperateSincePropValueChanged.current = false;
    }, [props.value]);
    (0,react.useEffect)(function () {
        var _isOutOfRange = value.less(minDecimal) || maxDecimal.less(value);
        // Don't correct the illegal value caused by prop value. Wait for user to take actions.
        if (_isOutOfRange && refHasOperateSincePropValueChanged.current) {
            setValue(getLegalValue(value));
        }
        setIsOutOfRange(_isOutOfRange);
    }, [minDecimal, maxDecimal, value, getLegalValue]);
    var handleArrowKey = function (event, method, needRepeat) {
        if (needRepeat === void 0) { needRepeat = false; }
        event.persist();
        event.preventDefault();
        setIsUserTyping(false);
        if (disabled || readOnly) {
            return;
        }
        var finalValue = value.isInvalid
            ? getDecimal(min === -Infinity ? 0 : min)
            : value.add(method === 'plus' ? step : -step);
        setValue(getLegalValue(finalValue));
        refInput.current && refInput.current.focus();
        // auto change while holding
        if (needRepeat) {
            var isFirstRepeat = refAutoTimer.current === null;
            refAutoTimer.current = setTimeout(function () { return event.target.dispatchEvent(event.nativeEvent); }, isFirstRepeat ? AUTO_CHANGE_START_DELAY : AUTO_CHANGE_INTERVAL);
        }
    };
    var displayedInputValue = (0,react.useMemo)(function () {
        var _value;
        if (isUserTyping) {
            _value = parser ? "" + parser(inputValue) : inputValue;
        }
        else if ((0,is/* isNumber */.hj)(mergedPrecision)) {
            _value = value.toString({ safe: true, precision: mergedPrecision });
        }
        else if (value.isInvalid) {
            _value = '';
        }
        else {
            _value = value.toString();
        }
        return formatter ? formatter(_value, { userTyping: isUserTyping, input: inputValue }) : _value;
    }, [value, inputValue, isUserTyping, mergedPrecision, parser, formatter]);
    var updateSelectionRangePosition = useSelectionRange({
        inputElement: (_b = refInput.current) === null || _b === void 0 ? void 0 : _b.dom,
        inputValue: displayedInputValue,
    });
    var inputEventHandlers = {
        onChange: function (rawText, event) {
            setIsUserTyping(true);
            rawText = rawText.trim().replace(/。/g, '.');
            var parsedValue = parser ? parser(rawText) : rawText;
            if ((0,is/* isNumber */.hj)(+parsedValue) || parsedValue === '-' || !parsedValue || parsedValue === '.') {
                setInputValue(rawText);
                setValue(getLegalValue(getDecimal(parsedValue)));
                updateSelectionRangePosition(event);
            }
        },
        onKeyDown: function (e) {
            e.stopPropagation();
            var key = e.key;
            if (key === keycode/* ArrowDown.key */.K5.key) {
                handleArrowKey(e, 'minus');
            }
            else if (key === keycode/* ArrowUp.key */.a2.key) {
                handleArrowKey(e, 'plus');
            }
            stop();
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
        },
        onFocus: function (e) {
            var _a, _b;
            // Both tab and button click trigger focus event. This can be used to determine whether user has taken operations
            refHasOperateSincePropValueChanged.current = true;
            setInputValue((_b = (_a = refInput.current) === null || _a === void 0 ? void 0 : _a.dom) === null || _b === void 0 ? void 0 : _b.value);
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        },
        onBlur: function (e) {
            setValue(getLegalValue(value));
            setIsUserTyping(false);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        },
    };
    var getControlButtonEventsHandlers = function (method) {
        return readOnly
            ? {}
            : {
                onMouseDown: function (e) { return handleArrowKey(e, method, true); },
            };
    };
    var shouldRenderButton = !hideControl && mode === 'button';
    var shouldRenderLayer = !hideControl && !readOnly && mode === 'embed';
    var renderStepButton = function (method, icon) {
        var _a;
        var isStepButtonValid = !disabled &&
            (value.isInvalid ||
                (method === 'plus'
                    ? maxDecimal.isInvalid || value.less(maxDecimal)
                    : minDecimal.isInvalid || minDecimal.less(value)));
        return (react.createElement("div", __assign({ className: (0,classNames/* default */.Z)(prefixCls + "-step-button", (_a = {},
                _a[prefixCls + "-step-button-disabled"] = !isStepButtonValid,
                _a)), onMouseLeave: stop, onMouseUp: stop }, (isStepButtonValid ? getControlButtonEventsHandlers(method) : {})), icon));
    };
    return (react.createElement(Input/* default */.Z, __assign({ _ignorePropsFromGlobal: true, role: "spinbutton", "aria-valuemax": max, "aria-valuemin": min, "aria-valuenow": value.isEmpty ? undefined : value.toNumber() }, (0,omit/* default */.Z)(rest, ['allowClear']), inputEventHandlers, { style: style, className: (0,classNames/* default */.Z)(prefixCls, prefixCls + "-mode-" + mode, prefixCls + "-size-" + mergedSize, (_a = {},
            _a[prefixCls + "-readonly"] = readOnly,
            _a[prefixCls + "-illegal-value"] = !value.isEmpty && isOutOfRange,
            _a), className), ref: refInput, size: mergedSize, error: error, disabled: disabled, readOnly: readOnly, value: displayedInputValue, placeholder: placeholder, prefix: prefix && react.createElement("div", { className: prefixCls + "-prefix" }, prefix), suffix: react.createElement(react.Fragment, null,
            shouldRenderLayer && (react.createElement("div", { className: prefixCls + "-step-layer" },
                renderStepButton('plus', icons && icons.up ? icons.up : react.createElement(IconUp/* default */.Z, null)),
                renderStepButton('minus', icons && icons.down ? icons.down : react.createElement(IconDown/* default */.Z, null)))),
            suffix && react.createElement("div", { className: prefixCls + "-suffix" }, suffix)), addBefore: shouldRenderButton &&
            renderStepButton('minus', icons && icons.minus ? icons.minus : react.createElement(IconMinus/* default */.Z, null)), addAfter: shouldRenderButton &&
            renderStepButton('plus', icons && icons.plus ? icons.plus : react.createElement(IconPlus/* default */.Z, null)) })));
}
var InputNumberComponent = react.forwardRef(InputNumber);
InputNumberComponent.displayName = 'InputNumber';
/* harmony default export */ var es_InputNumber = (InputNumberComponent);


/***/ }),

/***/ 2295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconUpComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-up")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    d: "M39.6 30.557 24.043 15 8.487 30.557"
  }));
}

var IconUp = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconUpComponent);
IconUp.defaultProps = {
  isIcon: true
};
IconUp.displayName = 'IconUp';
/* harmony default export */ __webpack_exports__["Z"] = (IconUp);

/***/ })

}]);